<template>
  <div>403 Forbiden!</div>
</template>

<script>
export default {

}
</script>

<style>

</style>